export class CompensationInputModel {
  userId: number
  calculatedDays: number
}
